module.exports = __webpack_public_path__ + "static/img/goods_list_more_cell_duihuan.7f7ef92e.png";